// PHASE 2: What would speaking this language truly mean to you?
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🦋',
    title: 'pages.onboarding.deeperMotivation.answer1',
    subtitle: 'pages.onboarding.deeperMotivation.answer1Subtitle',
  },
  {
    emoji: '🤝',
    title: 'pages.onboarding.deeperMotivation.answer2',
    subtitle: 'pages.onboarding.deeperMotivation.answer2Subtitle',
  },
  {
    emoji: '🏆',
    title: 'pages.onboarding.deeperMotivation.answer3',
    subtitle: 'pages.onboarding.deeperMotivation.answer3Subtitle',
  },
  {
    emoji: '🧠',
    title: 'pages.onboarding.deeperMotivation.answer4',
    subtitle: 'pages.onboarding.deeperMotivation.answer4Subtitle',
  },
  {
    emoji: '🌱',
    title: 'pages.onboarding.deeperMotivation.answer5',
    subtitle: 'pages.onboarding.deeperMotivation.answer5Subtitle',
  },
  {
    emoji: '💫',
    title: 'pages.onboarding.deeperMotivation.answer6',
    subtitle: 'pages.onboarding.deeperMotivation.answer6Subtitle',
  },
]

export default function DeeperMotivationPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.deeperMotivation.title"
      subtitle="pages.onboarding.deeperMotivation.subtitle"
    />
  )
}
